import React from 'react';
import CreateLenderForm from './Form';
import AdminNav from '../../admin/AdminNav';

const CreateLenderView = () => {
  return (
    <div>
      <AdminNav />
      <h1>Create Lender</h1>
      <CreateLenderForm />
    </div>
  );
};

export default CreateLenderView;
